/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectsEnumsDto } from '../../models/backend-projects-enums-dto';

export interface ProjectsProjectsEnumsRetrieve$Params {}

export function projectsProjectsEnumsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsProjectsEnumsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectsEnumsDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsEnumsRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectsEnumsDto>;
    }),
  );
}

projectsProjectsEnumsRetrieve.PATH = '/api/projects/projects/enums/';
